<div class="pos-absolute left-0 right-0 z-10 w-12 pe-auto meganav__content custom-scrollbar">
    <div class="hide-up-container bg-col-41 border-top">
        <div class="ng-hide hide-up wrap p-r-0 p-l-0"
             [toggleClass]="'!ng-hide'"
             [toggleClassBy]="meganavToggleGroupId"
             [elementHeight]="'meganav'">
            @for(item of items; track $index; let i = $index) {
            <div class="w-12 ng-hide hide-fade flex-top"
                 [class.flex]="item.right_image"
                 [ngSwitch]="item.zippy_mode"
                 [toggleClass]="'!ng-hide'"
                 [toggleClassBy]="[meganavToggleGroupId, i]"
                 (mouseenter)="handleMouseEnter(i)"
                 (mouseleave)="handleMouseLeave(i)"
                 pageHeaderMeganavContentArea>

                <!-- Simple columns -->
                <div *ngSwitchDefault
                     class="flex wrap p-b-3"
                     [ngClass]="item.center_submenu ? 'flex-justify-center' : 'flex-justify-between'"
                     [style.padding-right.rem]="item.right_image ? 0.75 : 1.5">

                    <ng-container *ngTemplateOutlet="tplColumns; context: { $implicit: item, navParent: item.text}">
                    </ng-container>

                </div>

                <!-- Submenu -->
                <div *ngSwitchCase="true"
                     class="flex col-1"
                     (mouseleave)="closeTab()">
                    <div class="w-3 p-t-5 p-b-5 bg-col-42 flex-column">

                        @for (tab of item.submenu; track $index; let j = $index) {
                        <div class="p-t-2 p-b-2 wrap w-12 cursor-pointer"
                             [class.bg-col-41]="currentOpen === j"
                             style="height: auto;"
                             (mouseenter)="openTab(tab, j)">
                            <p class="h4 col-1"
                               *iCms="'title' of tab">
                            </p>
                        </div>
                        }

                    </div>

                    @for(tab of item.submenu; track $index; let k = $index) {
                    <div class="bg-col-41 w-9 animation p-l-3"
                         [class.ng-hide]="currentOpen !== k">
                        <div class="flex flex-justify-between wrap"
                             [class.flex-justify-center]="item.center_submenu"
                             style="height: auto;">

                            <ng-container
                                          *ngTemplateOutlet="tplColumns; context: { $implicit: tab, navParent: item.text }">
                            </ng-container>

                        </div>
                    </div>
                    }
                </div>

                <!-- Right image -->
                @if (item.right_image && !item.zippy_mode) {

                <df-image-wrapper class="w-6 block pos-relative">
                    <img class="rf"
                         [dfImage]="item.image"
                         [ratio]="1"
                         [width]="imageWidth(16.5)" />
                    <div class="p-a-2 p-t-3 p-b-3 w-12 pos-absolute bottom-0 caption-bar">
                        <p class="p1 col-w"
                           *iCms="'caption' of item"></p>

                        <p class="h3 col-w"
                           *iCms="'image_title' of item"></p>
                    </div>
                </df-image-wrapper>
                }
            </div>
            }
        </div>
    </div>
</div>

<!---------- Column templates ---------->
<ng-template #tplImageAndCaption
             let-data
             let-submenuTitle='submenuTitle'
             let-navParent='navParent'>
    @if(data) {
    <href [link]="data.image_link"
          [ga4TrackClick]="getNavigationGA4Data(navParent, submenuTitle, data.image_title || data.title)">

        <df-image-wrapper>
            <div [ngClass]="data.ratio || 'ratio-3-4'"
                 [style.width]="imageWidth(data.width || 16.5)">
                <img class="rf"
                     [dfImage]="data.image"
                     [ratio]="data.ratio || 'ratio-3-4'"
                     [width]="imageWidth(data.width || 16.5)" />
            </div>
        </df-image-wrapper>

        <p class="p1 m-l-2 m-t-2 col-1"
           *iCms="'caption' of data; skipEmpty: true"></p>

        <p class="h3 m-l-2 m-t-1 col-1"
           *iCms="'image_title' of data; skipEmpty: true"></p>
    </href>
    }
</ng-template>

<ng-template #tplProducts
             let-data
             let-submenuTitle='submenuTitle'
             let-navParent='navParent'>
    @if(data?.products?.length) {
    <div [class.flex]="data?.products?.length > 1">

        @for (productId of data.products; track $index; let isLast = $last) {
        <div [style.width.px]="222"
             [class.m-r-3]="!isLast">
            <product [modelId]="productId"
                     [ga4MenuNavigation]="getNavigationGA4Data(navParent, submenuTitle)"></product>
        </div>
        }
    </div>
    }
</ng-template>

<ng-template #tplList
             let-data
             let-submenuTitle='submenuTitle'
             let-navParent='navParent'>
    @for(element of data.list; track $index; let isFirst = $first) {
    <href class="w-12"
          [link]="element.link">
        <div class="flex flex-middle"
             [ngClass]="!isFirst ?  element.list_variant === 'icon' ? 'm-t-1' : 'm-t-2' :''"
             [ngSwitch]="element.list_variant"
             [ga4TrackClick]="getNavigationGA4Data(navParent, submenuTitle, element.text)">

            <ng-container *ngSwitchCase="'title'">

                <p class="h4 col-1 m-t-5 m-b-1"
                   *iCms="'text' of element">
                </p>
            </ng-container>

            <ng-container *ngSwitchCase="'color'">
                @if (true) {
                <ng-container *ngTemplateOutlet="tplColor; context: { $implicit: element }">
                </ng-container>
                }
            </ng-container>

            <df-image-wrapper *ngSwitchCase="'icon'"
                              class="m-r-1">
                <img [dfImage]="element.image"
                     [ratio]="1"
                     [width]="40"
                     [height]="40"
                     [style.max-width]="'40px'"
                     [style.max-height]="'40px'" />
            </df-image-wrapper>

            @if (element.list_variant !== 'title') {

            <p class="p1 col-1"
               *iCms="'text' of element; skipEmpty: true"></p>
            }
        </div>
    </href>
    }
</ng-template>

<ng-template #tplColorWithSwatches
             let-data
             let-submenuTitle='submenuTitle'
             let-navParent='navParent'>
    <div class="colors flex flex-justify-between w-12 p-t-5 p-b-5"
         (mouseleave)="closeOpenColor()">
        <div [style.width]="imageWidth(48)">

            <p class="h4 col-1"
               style="min-height: 2.19rem;"
               *iCms="'title' of data; skipEmpty: true"></p>

            <div class="m-t-3"
                 [grid]="3">

                @for(element of data.color_list; track $index; let i = $index) {
                <href class="m-b-2 w-12"
                      [link]="element.link">
                    <div class="flex flex-middle"
                         (mouseenter)="showColorImage(element, i)"
                         [ga4TrackClick]="getNavigationGA4Data(navParent, submenuTitle, element.text)">

                        @if (true) {
                        <ng-container *ngTemplateOutlet="tplColor; context: { $implicit: element }">
                        </ng-container>
                        }

                        <p class="p1 col-1"
                           *iCms="'text' of element"></p>
                    </div>
                </href>
                }
            </div>
        </div>

        @for(element of data.color_list; track $index; let i = $index) {
        <div class="flex animation"
             [class.ng-hide]="currentColor !== i">
            @for(image of element.images; track $index; let isLast = $last) {
            <div [class.m-r-2]="!isLast">
                @if (true) {
                <ng-container
                              *ngTemplateOutlet="tplImageAndCaption; context: { $implicit: image, submenuTitle: element.text, navParent: navParent }">
                </ng-container>
                }
            </div>
            }
        </div>
        }
    </div>
</ng-template>

<!-- Template of color swatch -->
<ng-template #tplColor
             let-element>
    <div class="ratio-1-1 m-r-2 b-col-42"
         [class.b-a]="element.color === 'rgba(255, 255, 255, 1)'"
         [style.width]="imageWidth(3.33)">

        @if (element.color) {
        <div class="fill"
             [ngStyle]="{'background-color': element.color || 'rgb(255, 255, 255)'}"></div>
        }

        @if (element.new_color) {
        <p class="pos-absolute top-50 left-50 c1 italic"
           [ngClass]="element.new_text_color"
           style="transform: translate(-50%, -50%);">{{'New' | translate}}</p>
        }
    </div>
</ng-template>

<ng-template #tplColumns
             let-element
             let-navParent='navParent'>

    <!-- List and colors -->
    @if (hasColumnsToShow(element.columns)) {
    <div class="flex flex-top"
         [class.w-12]="!element.center_submenu">
        @for(column of element.columns; track $index; let isFirst = $first) {
        @if (canShowColumn(column)) {
        <div [ngClass]="column.variant==='colors'? 'w-12 p-t-1': 'm-r-2 p-t-5 p-b-5'"
             [style.min-width]="imageWidth(15.4)"
             [ngSwitch]="column.variant">


            <p class="h4"
               style="min-height: 2.6rem;"
               [ngClass]="column.title_color || 'col-1'"
               *iCms="'title' of column; skipEmpty: !showTitleOrSpace(column)"></p>

            <ng-container *ngSwitchCase="'list'">
                @if (true) {
                <ng-container
                              *ngTemplateOutlet="tplList; context: { $implicit: column, submenuTitle: element.title || column.title, navParent: navParent }">
                </ng-container>
                }
            </ng-container>

            <ng-container *ngSwitchCase="'colors'">
                @if (true) {
                <ng-container
                              *ngTemplateOutlet="tplColorWithSwatches; context: { $implicit: column, submenuTitle: element.title || column.title, navParent: navParent }">
                </ng-container>
                }
            </ng-container>

            <!-- button -->
            <div class="p1 m-t-2 col-1 underline">
                <a [routerLink]="column.cta_link"
                   [ga4TrackClick]="getNavigationGA4Data(navParent, element.title || column.title, column.cta_label)"
                   *iCms="'cta_label' of column"></a>
            </div>
        </div>
        }
        }
    </div>
    }

    <!-- Products and images -->
    @if (hasImageProductColumnsToShow(element.columns)) {
    <div class="flex flex-top">

        @for(column of element.columns; track $index; let isLast = $last) {
        @if (canShowImageProductColumn(column)) {
        <div class="p-t-5 p-b-5"
             [class.m-r-3]="!isLast"
             [ngSwitch]="column.variant">

            <p class="h4 col-1"
               style="min-height: 2.19rem;"
               [ngClass]="column.title_color || 'col-1'"
               *iCms="'title' of column; skipEmpty: !showTitleOrSpace(column)"></p>

            <ng-container *ngSwitchCase="'image'">
                @if (true) {
                <ng-container
                              *ngTemplateOutlet="tplImageAndCaption; context: { $implicit: column, submenuTitle: element.title || column.title, navParent: navParent }">
                </ng-container>
                }
            </ng-container>

            <ng-container *ngSwitchCase="'products'">
                @if (true) {
                <ng-container
                              *ngTemplateOutlet="tplProducts; context: { $implicit: column, submenuTitle: element.title || column.title, navParent: navParent }">
                </ng-container>
                }
            </ng-container>

            <!-- button -->
            <div class="p1 m-t-2 col-1 underline"
                 [class.m-l-2]="column.variant === 'image'">
                <a [routerLink]="column.cta_link"
                   [ga4TrackClick]="getNavigationGA4Data(navParent, element.title || column.title, column.cta_label)"
                   *iCms="'cta_label' of column"></a>
            </div>
        </div>
        }
        }
    </div>
    }
</ng-template>